import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { HtmlWrapper } from '@/components/atoms/HtmlWrapper';
import { Typography } from '@/components/atoms/Typography';

import { FlattenedSuggestion, flattenSuggestions } from './utils';

export interface Suggestion {
  id?: string;
  values: Value[];
  text?: string;
  onClick?: (id?: string) => void;
}

export interface Value {
  text: string;
  id: string;
  important?: boolean;
  displayedText?: string;
}

type Props = {
  suggestions?: Suggestion[];
  match?: string;
  onSelectSuggestion: (suggestion: FlattenedSuggestion) => void;
};

export const AutoCompleteList: FC<Props> = ({ suggestions, match = '', onSelectSuggestion }) => {
  const { t } = useTranslation();
  const flattenedSuggestions = flattenSuggestions(suggestions);
  const getMatchingPart = (text: string, part: string) => {
    if (!part) {
      return text;
    }
    const strippedPart = part.replace(/[^\w\s]/gi, '');

    const wordParts = strippedPart.split(/[ ,]+/).filter(Boolean);

    let matches = text;
    for (let i = 0; i < wordParts.length; i++) {
      const regExp = new RegExp(wordParts[i], 'gi');
      matches = matches.replace(regExp, (found) => `<b>${found}</b>`);
    }

    return matches;
  };

  return (
    <div className="absolute bg-white  overflow-y-auto mt-1 w-full z-50 drop-shadow-md rounded-xl">
      {flattenedSuggestions &&
        flattenedSuggestions.map((suggestion, index) => {
          const contentText = getMatchingPart(suggestion?.displayedText || suggestion.text, match);
          const formattedContent = suggestion.id === '-1' ? `${t('action.addNewRestaurant')}: ${contentText}` : contentText;
          return (
            <div key={suggestion.id + index}>
              <button className="hover:bg-shades-quaternary-hover hover:cursor-pointer w-full py-3 px-5" onClick={() => onSelectSuggestion(suggestion)}>
                <Typography variant="paragraph" align="left">
                  <HtmlWrapper content={formattedContent} />
                </Typography>
              </button>
              <hr />
            </div>
          );
        })}
    </div>
  );
};
